import { Suspense } from 'react';
import ReactDOM from 'react-dom/client';

// i18n
import './lib/i18n/i18n';

// Tailwind css
import './tailwind.css';

// Router
import { RouterProvider } from 'react-router-dom';
import './lib/axios/axios-global';
import router from './core/global-router';
import { Provider } from 'react-redux';
import store from './core/global-store';
import LangSettings from './lib/i18n/LangSettings';
import { Toaster } from './components/ui/sonner';

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
    <Provider store={store}>
        <LangSettings>
            <Suspense>
                <RouterProvider router={router} />
                <Toaster />
            </Suspense>
        </LangSettings>
    </Provider>,
);
